import { configureStore } from "@reduxjs/toolkit";
import { persistStore, persistReducer } from "redux-persist";
import storage from "redux-persist/lib/storage"; // defaults to localStorage for web
import { combineReducers } from "redux";
import { thunk } from "redux-thunk";
import userReducer from "./features/user/userSlice";
import filterReducer from "./features/user/filterSlice";
import userTourReducer from "./features/user/userTourSlice"


const persistConfig = {
  key: "root",
  storage,
};

// let clientList = [];

const rootReducer = combineReducers({
  user: userReducer,
  filter:filterReducer,
  tour:userTourReducer
});

const persistedReducer = persistReducer(persistConfig, rootReducer);

const store = configureStore({
  reducer: persistedReducer,
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: false,
    }).concat(thunk),
});

const persistor = persistStore(store);

export { store, persistor };
